module.exports = __webpack_public_path__ + "img/sweep-coin.c7f36a77.png";